<template>
<div class="card social-timeline">
    <div class="card-header">
        <h2 class="card-title py-1 my-0">
            <i class="fab fa-facebook fa-lg" v-if="social_timeline.social_type == 'facebook'"></i>
            <i class="fab fa-x-x fa-lg" v-else-if="social_timeline.social_type == 'x'"></i>
            {{social_timeline.url | stripUri}}
        </h2>
        <div class="card-tools">
            <span v-if="monitoring" class="blink d-inline-block">
                {{translate('messages.monitoring')}} 
            </span>
            <button class="btn btn-tool no-shadow" @click="toggleMonitor" v-tooltip:bottom="translate('messages.activate_deactivate_monitoring')" data-toggle="tooltip">
                <radar :monitoring="monitoring"/>
            </button>
        </div>
    </div>
    <div class="card-body p-0">
        <div v-if="social_timeline.social_type == 'facebook'" class="fb-page" :data-href="social_timeline.url" data-tabs="timeline" data-width="500" data-height="500" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" ><blockquote :cite="social_timeline.url" class="fb-xfbml-parse-ignore"><a :href="social_timeline.url">Facebook</a></blockquote></div>

        <a v-else-if="social_timeline.social_type == 'x'" class="x-timeline"
            :href="social_timeline.url"
            data-height="500"
            :data-theme="theme"
            >
        </a>

    </div>
    <div v-if="loading" class="overlay dark">
        <i class="fas fa-sync fa-spin fa-2x"></i>
    </div>
</div>
</template>
 
<script>
export default {
    props: ['social_timeline'],
    data () {
        return {
            entries : [],
            loading : true,
            fb_script : 'https://connect.facebook.net/es_LA/sdk.js',
            tw_script : 'https://platform.twitter.com/widgets.js',
            monitoring : false,
            timer: null,
            theme: ''
        }
    },
    methods: {
        reloadFb() {
            if(typeof(FB) === 'undefined') return;
            var timeout = null;
            if(timeout != null) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function(){
                FB.XFBML.parse();
            },1000);
        },
        reloadTw(){
            twttr.widgets.load();
        },
        toggleMonitor(){
            this.monitoring = !this.monitoring;
            if(this.monitoring){
                this.timer = setInterval(function(){
                    if(this.social_timeline.social_type == "facebook"){
                        this.reloadFb;
                    }else if(this.social_timeline.social_type == "x"){
                        this.reloadTw;
                    }
                    this.$forceUpdate();
                }.bind(this), 60 * 1000);
            }else{
                clearInterval(this.timer);
            }
        }
        
    },
    mounted() {
        if(this.social_timeline.social_type == "facebook"){
            var fb_root_e = document.getElementsByClassName('fb-root');
            if(!fb_root_e.length){
                let fb_root = document.createElement('div');
                fb_root.className = 'fb-root';
                var s = document.body.firstChild;
                s.parentNode.insertBefore(fb_root, s);
            }
            
            Vue.loadScript(this.fb_script).then(() => {
                FB.init({
                    xfbml: true,
                    version: 'v11.0'
                });
                this.loading = false;
                window.addEventListener("resize", this.reloadFb);
            })
            .catch(() => {
            // error
            });
            
        }else if(this.social_timeline.social_type == "x"){
            this.theme = $('body').hasClass('dark-mode') ? 'dark' : '';
            Vue.loadScript(this.tw_script).then(() => {
                this.loading = false;
            })
            .catch(() => {
            // error
            });
        };
    },
    created() {
    },
    beforeDestroy() {
        if(this.timer) clearInterval(this.timer);
        window.removeEventListener("resize", this.reloadFb);
        if(this.social_timeline.social_type == "facebook") Vue.unloadScript(this.fb_script).then(() => {}).catch(() => {});
        else if(this.social_timeline.social_type == "x") Vue.unloadScript(this.tw_script).then(() => {}).catch(() => {});
    },
    filters: {
        stripUri: function (url) {
            url = url.replace(/\/$/, "");
            return url.substring(url.lastIndexOf('/') + 1);
        }
    }
}
</script>